import React, { useState, useMemo } from 'react';
import cronstrue from 'cronstrue';
import { Input } from './ui/Input';
import { Button } from './ui/Button';

const PRESETS = [
  { label: 'Щохвилини', value: '* * * * *' },
  { label: 'Щогодини', value: '0 * * * *' },
  { label: 'Щодня о 3:00', value: '0 3 * * *' },
  { label: 'Щотижня нд', value: '0 3 * * 0' },
];

interface CronBuilderProps {
  value: string;
  onChange: (val: string) => void;
}

function getNextFires(cron: string, count = 3): string[] {
  // Simple next-fire calculation using Date
  // Returns next N fire times as locale strings
  try {
    const parts = cron.trim().split(/\s+/);
    if (parts.length !== 5) return [];

    // We can't do full cron math without a lib; return empty to avoid wrong info
    return [];
  } catch {
    return [];
  }
}

export function CronBuilder({ value, onChange }: CronBuilderProps) {
  const humanReadable = useMemo(() => {
    try {
      return cronstrue.toString(value, { locale: 'uk' });
    } catch {
      try {
        return cronstrue.toString(value);
      } catch {
        return 'Невірний вираз';
      }
    }
  }, [value]);

  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-wrap gap-1">
        {PRESETS.map((p) => (
          <Button
            key={p.value}
            variant="outline"
            size="sm"
            type="button"
            onClick={() => onChange(p.value)}
          >
            {p.label}
          </Button>
        ))}
      </div>
      <Input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="* * * * *"
        className="font-mono"
      />
      <div className="text-xs text-tg-accent">{humanReadable}</div>
      <div className="text-xs text-tg-text-secondary">
        Формат: хв год день місяць день_тижня
      </div>
    </div>
  );
}
